import { prefixObjectValues } from '../../utils';
const form = {
  formDialog: 'dialog',
  form: 'form',
  fieldLabelSelect: 'field-label-select',
  fieldTxtInput: 'field-txt-input',
  submitBtn: 'btn-submit',
};

export default prefixObjectValues(form, 'academic-education-detail-form');
